import { render, staticRenderFns } from "./downloadDetailbox.vue?vue&type=template&id=32f8dc07&scoped=true&"
import script from "./downloadDetailbox.vue?vue&type=script&lang=js&"
export * from "./downloadDetailbox.vue?vue&type=script&lang=js&"
import style0 from "./downloadDetailbox.vue?vue&type=style&index=0&id=32f8dc07&scoped=scoped&lang=scss&"
import style1 from "./downloadDetailbox.vue?vue&type=style&index=1&id=32f8dc07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f8dc07",
  null
  
)

export default component.exports